import "jquery/dist/jquery.min";
import "jquery-validation/dist/jquery.validate.min";
import "jquery-validation/dist/additional-methods.min";
import { Constants } from "../ENVIROMENT_VARIABLES";

import jquery from "jquery";
// API CALLING FOR PRE TOKEN
var Temp_Token=JSON.parse(sessionStorage.getItem('TP_Token'));
const originUrl = window.location.origin;


// API CALLING FOR BRANCH LIST
  $.ajax({
    type: "POST",
    url:`${Constants.BASE_URL}thirdParty/getBranches.srvc?method=POST`,
    headers: {
        'Accept': 'application/json',
        'Content-Type':'application/json',
        'Data-Type': 'json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': 'Content-Type , Authorization',
        'Access-Control-Allow-Credentials': 'true',
        'Authorization': `Bearer ${Temp_Token.Token}`
    },
    success: function (data) {
      for(let i=0; i<data.length; i++){
        $('#branchId').append($(`<option value="${data[i].rid}">${data[i].name.en_us} | ${data[i].name.ar_jo}</option>`));
      }
    },
    error:function(data){

    }

  });


const register_form = $("#register-form");
register_form.validate({
  errorClass: "invalid",
  validClass: "valid",
  rules: {
    Name: {
      required: true,
      minlength: 3,
    },
    Name_ar: {
      required: true,
      minlength: 3,
    },
    Se_name: {
      required: true,
      minlength: 3,
    },
    Se_name_ar: {
      required: true,
      minlength: 3,
    },
    third_name: {
      required: true,
      minlength: 3,
    },
    third_name_ar: {
      required: true,
      minlength: 3,
    },
    last_name: {
      required: true,
      minlength: 3,
    },
    third_name_ar: {
      required: true,
      minlength: 3,
    },
    
    PhoneNumber: {
      required: true,
      phoneNumberFormat:true
    },
    Email: {
      required: true,
      email: true,
    },
    Gender: {
      required: true,
    },
    isMobileOwner:{
      required:true
    },
    DateOfBirth: {
      required: true,
    },
    Address: {
      required: true,
      minlength: 6,
    },
    Branch: {
      required: true,
    },
    ResidenceNumber: {
      required: true,
      number: true,
    },
    otpNumber:{
      required: true,
      number: true,
    },
    isMobileOwner:{
      required: true,
    }
  },
  onfocusout: function (element) {
    this.element(element); // triggers validation
  },
  onkeyup: function (element, event) {
    this.element(element); // triggers validation
  },
  messages: {
    Name: {
      required: "Full Name is required",
      minlength: "Enter your full name",
    },
    Name_ar: { 
      required: "Full Name In Arabic is required",
      minlength: "Enter your full name in arabic",
    },
    Se_name: {
      required: "Second Name is required",
      minlength: "Enter your second name",
    },
    Se_name_ar: { 
      required: "Second Name In Arabic is required",
      minlength: "Enter your second name in arabic",
    },
    third_name: {
      required: "Second Name is required",
      minlength: "Enter your Third name",
    },
    third_name_ar: {
      required: "Second Name is required",
      minlength: "Enter your Third name",
    },
    last_name: {
      required: "Last Name is required",
      minlength: "Enter your Last name",
    },
    last_name_ar: {
      required: "Last Name is required",
      minlength: "Enter your Last name",
    },
    PhoneNumber: {
      required: "Phone number is required",
    },
    Email: {
      required: "Email is required",
      email: "Enter a valide Email in correct format",
    },
    DateOfBirth: {
      required: "Birth Day is required",
    },
    Address: {
      required: "Addresse is required",
      minlength: "Enter a valid Addresse",
    },
    Gender: {
      required: "Gender is required",
    },
    isMobileOwner:{
      required: "OwnerShip is required",
    },
    Branch: {
      required: "Branch is required",
    },
    ResidenceNumber: {
      required: "NationalID is required",
      number: "Enter Valid NationalID ",
    },
    otpNumber:{
      required: "OTP Number is required",
    }
  },
  errorElement: "em",
  errorPlacement: function (error, element) {
    // Add the `help-block` class to the error element
    error.addClass("alert alert-danger d-flex align-items-center mt-2");

    // Add `has-feedback` class to the parent div.form-group
    // in order to add icons to inputs
    element.parents(".input-field").addClass("is-invalid");

    if (element.prop("type") === "checkbox") {
      error.insertAfter(element.parent("label"));
    } else {
      error.insertAfter(element);
    }
  },
  success: function (label, element) {
    // //console.log('success');
    //hide error alert
    $(element).addClass("is-valid").removeClass("-invalid");
    $(element)
      .siblings("em")
      .removeClass("alert alert-danger d-flex align-items-center mt-2");
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass("is-invalid").removeClass("is-valid");
    // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
    $(element)
      .siblings("em")
      .addClass("alert alert-danger d-flex align-items-center mt-2");
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass("is-valid").removeClass("is-invalid");
    $(element)
      .siblings("em")
      .removeClass("alert alert-danger d-flex align-items-center mt-2");
  },
  submitHandler: function (register_form) {
    let userBirthday = $(register_form).find("#register_date").val();
    var dateformatter = new Date(userBirthday);
    var birthHolder = dateformatter.toISOString();
    if (document.querySelector("#register_male").checked) {
      var gender = 'MALE';
    } else {
      var gender = 'FEMALE';
    }
    if (document.querySelector("#isMobileOwner_yes").checked) {
      var isMobileOwner = true;
    } else {
      var isMobileOwner = false;
    }
   
    var formData = {
      firstName:{
        "en_us": $(register_form).find("#register_firstname").val(),
        "ar_jo": $(register_form).find("#register_firstname_ar").val()
      },
      secondName:{
        "en_us": $(register_form).find("#register-secondname").val(),
        "ar_jo": $(register_form).find("#register_secondname_ar").val()
      },
      thirdName:{
        "en_us": $(register_form).find("#register_thirdname").val(),
        "ar_jo": $(register_form).find("#register_thirdname_ar").val()
      },
      lastName:{
        "en_us": $(register_form).find("#register_lastname").val(),
        "ar_jo": $(register_form).find("#register_lastname_ar").val()
      },
      mobileNo: $(register_form).find("#register_phone").val(),
      email:  $(register_form).find("#register_email").val(),
      dateOfBirth: birthHolder,
      address:{
        "en_us": $(register_form).find("#register_address").val(),
        "ar_jo":  $(register_form).find("#register_address_ar").val()
      },
      nationalId:$(register_form).find("#register_residenceID").val(),
      gender: gender,
      branchId:  $(register_form).find("#branchId").val(),
      isMobileOwner:isMobileOwner,
      otp:$(register_form).find("#otpNumber").val()
    };
    $.ajax({
      url: `${Constants.BASE_URL}thirdParty/createPatient.srvc?method=POST`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data:JSON.stringify(formData),
      beforeSend: function (xhr) {
        xhr.setRequestHeader("Authorization", `Bearer ${Temp_Token.Token}`);
        
      },
      success: function (response) {
        $("#loading-overlay").hide();
        $("#sucess_registeration").fadeIn(500);
        $("#successtext").text("Your new account is created successfully");
        $("#successAlert").fadeIn(500);
        window.location.href = `${originUrl}/login.html`;

      },
      error: function (xhr) {
        $("#failedAlert").text(error);
          $("#failedAlert").fadeOut(400);
         //console.log(error)
       
      },
    });
  },
});

jquery.validator.addMethod("phoneNumberFormat", function(value, element) {
  return this.optional(element) || /^[0-9]{9}$/.test(value);
}, "Please Enter Only 9 Numbers Without Country Code +96");
        
               

//control date of birth

var todaysDate = new Date(); // Get today's date.
// Get today's date.
var year = todaysDate.getFullYear(); // yyyy
var month = ("0" + (todaysDate.getMonth() - 1)).slice(-2); // mm
var day = ("0" + todaysDate.getDate()).slice(-2); // dd
var dtToday = year + "-" + month + "-" + day; // Results in yyyy-mm-dd
// //console.log( new Date().toISOString().substring(0, 10));
// //console.log( dtToday)
$("#register-birthDate").attr("max", dtToday);


//append country prefix as attr value in value
// var phone_prefeix= "00966";
// var inputNumber=''
// $("#register_phone").keyup(function() {
//   inputNumber=$("#register_phone").val();
//   var finalNumber=phone_prefeix+inputNumber;
//  $("#register_phone").attr("value",finalNumber)
// });







document.addEventListener('DOMContentLoaded', function() {
  var modal = $('#otp-modal');
  var overlay = $('.modal-overlay');

  modal.css('display', 'block');
  overlay.css('display', 'block');
});


// Resend OTP Code
$('#resend-otp').click(function() {
  var modal = $('#otp-modal');
  var overlay = $('.modal-overlay');

  modal.css('display', 'block');
  overlay.css('display', 'block');
});
// Send OTP

const login_form = $("#login_form");
login_form.validate({
  errorClass: "invalid",
  validClass: "valid",
  // errorElement: "em",
  rules: {
    Username: {
      required: true,
      phoneNumberFormat:true
    }
  },
  onfocusout: function (element) {
    this.element(element); // triggers validation
  },
  onkeyup: function (element, event) {
    this.element(element); // triggers validation
  },
  messages: {
    Username: {
      required: "Phone number is required",
    }
  },
  errorElement: "em",
  errorPlacement: function (error, element) {
    // Add the `help-block` class to the error element
    error.addClass("alert alert-danger d-flex align-items-center mt-2");

    // Add `has-feedback` class to the parent div.form-group
    // in order to add icons to inputs
    element.parents(".input-field").addClass("is-invalid");

    if (element.prop("type") === "checkbox") {
      error.insertAfter(element.parent("label"));
    } else {
      error.insertAfter(element);
    }
  },
  success: function (label, element) {
    //hide error alert
    $(element).addClass("is-valid").removeClass("-invalid");
    $(element)
      .siblings("em")
      .removeClass("alert alert-danger d-flex align-items-center mt-2");
  },
  highlight: function (element, errorClass, validClass) {
    $(element).addClass("is-invalid").removeClass("is-valid");
    // $( element ).next( "span" ).addClass( "is-valid" ).removeClass( "is-invalid" );
    $(element)
      .siblings("em")
      .addClass("alert alert-danger d-flex align-items-center mt-2");
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).addClass("is-valid").removeClass("is-invalid");
    $(element)
      .siblings("em")
      .removeClass("alert alert-danger d-flex align-items-center mt-2");
  },
  submitHandler: function (login_form) {
      let userphone = $(login_form).find("#Username").val();
      var dataForm={
          mobileNumber:userphone
        }
      $.ajax({
        url: `${Constants.BASE_URL}thirdParty/sendRegistrationOtp.srvc?method=POST`,
        method: "POST",
        headers: {
          "Content-Type":"application/json",
          Accept: "application/json",
        },
        data:JSON.stringify(dataForm),
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${Temp_Token.Token}`);
          
        },
        success: function (response) {
          setTimeout(function () {
            $("#loading-overlay").hide();
            $(".modal-overlay").hide();
            $(".modal-body").hide();
            $("#otp-modal").hide();
            $('#successtext').text("OTP Code send sucessfully");
            $('#successAlert').fadeIn(500)  
            $('#successAlert').fadeOut(500)  
            $('#otp-modal').addClass('z-index')

            // var modal = document.getElementById('otp-modal');
            // var overlay = document.querySelector('.modal');
            // modal.style.display = 'none';
            // overlay.style.display = 'none';
          }, 1000);;
        },
        error: function (xhr) {
          $("#loading-overlay").hide();
            // Handle the error response
          $("#failedAlert").text(error);
          $("#failedAlert").fadeOut(400);
         //console.log(error)
       
        },
      });

  

      
  },
});


jquery.validator.addMethod("phoneNumberFormat", function(value, element) {
  return this.optional(element) || /^[0-9]{9}$/.test(value);
}, "Please Enter Only 9 Numbers Without Country Code +96");
        
               


//append country code prefiex to phone number value
// var phone_prefeix= "00966";
// var inputNumber=''
// $("#Username").keyup(function() {
//   inputNumber=$("#Username").val();
//   var finalNumber=phone_prefeix+inputNumber;
//  $("#Username").attr("value",finalNumber)
// });
